module.exports = __webpack_public_path__ + "static/vxlu-425a0fcd548b24933a79a217382b023b.png";